import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { PageNotFoundComponent } from '@kpmg-tax/ui';
import { AuthGuard } from './core';
import { role } from 'src/app/shared/constants/role-enum';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './home';
import { AppLandingComponent } from './app-landing.component';
import { WelcomeComponent } from './welcome/welcome/welcome.component';
import { RouteTitle } from './shared/constants/route-title';
import { ManageStudyComponent } from './manage-study/manage-study.component';
import { SurveyAppComponent } from './survey-app/survey-app.component';
import { StudyIdResolver } from './shared/impersonation/study-id.resolver';
import { ClientManagerAuthGaurd } from './core/auth/client-manager-auth.gaurd';

export const routes: Routes = [
  { path: 'page-not-found', component: PageNotFoundComponent },
  {
    path: '',
    component: AppLandingComponent,
    pathMatch: 'full',
    canActivate: [MsalGuard],
  },
  {
    path: 'welcome',
    component: WelcomeComponent,
    pathMatch: 'full'
  },
  {
    path: 'survey-app',
    component: SurveyAppComponent,
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { roles: [role.admin, role.champion, role.clientAdmin] },
    title: RouteTitle.KPMG_HOME
  },
  {
    path: 'home/Client/:ClientMasterRefId',
    component: HomeComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { roles: [role.admin, role.champion, role.clientAdmin] },
    title: RouteTitle.KPMG_HOME
  },
  {
    path: 'home/client/:ClientMasterRefId',
    component: HomeComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { roles: [role.admin, role.champion, role.clientAdmin] },
    title: RouteTitle.KPMG_HOME
  },
  {
    path: 'study-add',
    component: ManageStudyComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { roles: [role.admin, role.champion, role.clientAdmin] }
  },
  {
    path: 'study-edit/:studyId',
    component: ManageStudyComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { roles: [role.admin, role.champion, role.clientAdmin] }
  },
  {
    path: 'study/:studyId',
    loadChildren: () => import('./study-home/study-home.module').then(m => m.StudyHomeModule),
    canActivate: [MsalGuard, AuthGuard],
    data: { roles: [role.admin, role.champion, role.clientAdmin, role.clientManager, role.respondent] },
    resolve: [StudyIdResolver]
  },
  {
    path: 'surveys',
    loadChildren: () => import('./survey-insight/survey-insight.module').then(m => m.SurveyInsightModule),
    canActivate: [MsalGuard, AuthGuard],
    data: { roles: [role.admin, role.champion, role.clientManager, role.respondent, role.clientAdmin] }
  },
  {
    path: 'studies',
    loadChildren: () => import('./survey-insight/survey-insight.module').then(m => m.SurveyInsightModule),
    canActivate: [MsalGuard, AuthGuard, ClientManagerAuthGaurd],
    data: { roles: [role.admin, role.champion, role.clientManager] }
  },
  { path: 'admin', redirectTo: '/home', pathMatch: 'full' },
  {
    // There are 2 paths with same 'admin'. Is this block accesible?
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [MsalGuard, AuthGuard],
    data: { roles: [role.admin, role.champion, role.clientAdmin] }
  },
  // {
  //   path: 'rcnsurvey',
  //   component: PageNotFoundComponent,
  //   pathMatch: 'full',
  //   canActivate: [MsalGuard, AuthGuard],
  //   data: { roles: [role.admin, role.champion, role.clientAdmin, role.clientManager] }
  // },
  { path: 'logout', redirectTo: '/home', pathMatch: 'full' },
  { path: 'null', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules, enableTracing: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
